import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { Img } from "arv-reactcomponents";

import Anchor from "../../Anchor";
import { PDP_BANNERSLOT_URL, Endpoints } from "npmlinks-constants";

const url = PDP_BANNERSLOT_URL;

@inject("CommonStore")
@observer
class PdpBannerSlot extends Component {
  get getLink() {
    const { isDesktop } = this.props.CommonStore;
    return (
      (isDesktop && Endpoints.PDP_BANNER_IMAGES.desktop) ||
      Endpoints.PDP_BANNER_IMAGES.mobile
    );
  }

  render() {
    if (this.getLink) {
      return (
        <Anchor.component href={url} to={url} target="_self">
          <Img
            className="nw-pdpbannerslot"
            src={this.getLink}
            alt="BannerImage"
          />
        </Anchor.component>
      );
    }
    return null;
  }
}

PdpBannerSlot.wrappedComponent.propTypes = {
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: PdpBannerSlot.wrappedComponent,
  component: PdpBannerSlot,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PdpComponents/PdpBannerSlot/index.js